// ============================================================
// Datei: src/pages/ressorts/kommunikation/KommunikationDesktop.jsx
//
// ÄNDERUNGEN:
// - ShiftTable jetzt mit departmentName
// - automatische Aktualisierung bleibt erhalten
// - bei nur einem Block ist kein filterFn nötig
// ============================================================

import React, { useState } from "react";

import VolunteerList from "../../../components/VolunteerList";
import ShiftTable from "../../../components/shiftTable/ShiftTable";
import EditVolunteerModal from "../../../components/EditVolunteerModal";

// ================= GUESTS =================
import GuestRegistration from "../../../components/GuestRegistration";
import GuestList from "../../../components/guestList/GuestList";
import EditGuestModal from "../../../components/guestList/EditGuestModal";
import DeleteGuestModal from "../../../components/guestList/DeleteGuestModal";
import VolunteerPool from "../../../components/VolunteerPool";

import "./kommunikation.css";

const KommunikationDesktop = ({
	volunteers,
	setVolunteers,
	shifts,
	guests,
	selectedVolunteer,
	setSelectedVolunteer,
	activeTab,
	setActiveTab,
	reloadGuests,
	reloadVolunteers
}) => {
	const [guestToEdit, setGuestToEdit] = useState(null);
	const [guestToDelete, setGuestToDelete] = useState(null);

	const fotographers = shifts.filter(
		(s) => s.shiftId >= 950 && s.shiftId <= 959
	);

	const tabs = [
		{ id: "overview", label: "Übersicht" },
		{ id: "helpers", label: "Libellen" },
		{ id: "shifts", label: "Schichtplan" },
		{ id: "guests", label: "Gästeliste" },
		{ id: "extras", label: "Extrawürscht" }
	];

	return (
		<>
			<div className="tabs-container">
				<div className="tab-bar">
					{tabs.map((t) => (
						<button
							key={t.id}
							type="button"
							className={
								"tab-button" +
								(activeTab === t.id ? " tab-button-active" : "")
							}
							onClick={() => setActiveTab(t.id)}
						>
							{t.label}
						</button>
					))}
				</div>

				<div className="tab-panels">
					{activeTab === "helpers" && (
						<div className="helpers-layout">
							<div className="helpers-column helpers-column-left">
								<VolunteerList
									volunteers={volunteers}
									setVolunteers={setVolunteers}
									onEdit={(v) => setSelectedVolunteer(v)}
									reloadVolunteers={reloadVolunteers}
								/>
							</div>

							<div className="helpers-column helpers-column-right">
								<VolunteerPool
									departmentName="Kommunikation"
									onAssigned={() => {
										if (reloadVolunteers) reloadVolunteers();
									}}
								/>
							</div>
						</div>
					)}

					{activeTab === "shifts" && (
						<>
							<h3 className="kommunikation-subheading">
								Fotograf:innen
							</h3>

							<ShiftTable
								shifts={fotographers}
								departmentName="Kommunikation"
								autoRefresh={true}
							/>
						</>
					)}

					{activeTab === "guests" && (
						<>
							<GuestRegistration refreshGuestList={reloadGuests} />

							<GuestList
								guests={guests}
								refreshGuestList={reloadGuests}
								onEdit={(g) => setGuestToEdit(g)}
								onDelete={(g) => setGuestToDelete(g)}
							/>
						</>
					)}
				</div>
			</div>

			{selectedVolunteer && (
				<EditVolunteerModal
					volunteer={selectedVolunteer}
					onClose={() => setSelectedVolunteer(null)}
					onSaved={reloadVolunteers}
				/>
			)}

			{guestToEdit && (
				<EditGuestModal
					guest={guestToEdit}
					onClose={() => setGuestToEdit(null)}
					onSaved={() => {
						setGuestToEdit(null);
						reloadGuests();
					}}
				/>
			)}

			{guestToDelete && (
				<DeleteGuestModal
					guest={guestToDelete}
					onClose={() => setGuestToDelete(null)}
					onDeleted={() => {
						setGuestToDelete(null);
						reloadGuests();
					}}
				/>
			)}
		</>
	);
};

export default KommunikationDesktop;